// 아직 개발되지 않은 화면의 임시 컴포넌트
import React from 'react';

const PlaceholderPage = ({ title }) => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '400px',
      color: '#888',
    }}>
      <div style={{ fontSize: '3rem', marginBottom: '16px' }}>🚧</div>
      <h2 style={{ fontSize: '1.5rem', marginBottom: '8px' }}>{title}</h2>
      <p>개발 예정입니다.</p>
    </div>
  );
};

export default PlaceholderPage;
